/* tslint:disable */
/* eslint-disable */
/**
 * CrateHackers API
 * This is the thing that does data stuff.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the KeyDto interface.
 */
export function instanceOfKeyDto(value) {
    if (!('camelot' in value) || value['camelot'] === undefined)
        return false;
    if (!('standard' in value) || value['standard'] === undefined)
        return false;
    return true;
}
export function KeyDtoFromJSON(json) {
    return KeyDtoFromJSONTyped(json, false);
}
export function KeyDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'camelot': json['camelot'],
        'standard': json['standard'],
    };
}
export function KeyDtoToJSON(json) {
    return KeyDtoToJSONTyped(json, false);
}
export function KeyDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'camelot': value['camelot'],
        'standard': value['standard'],
    };
}
